import React from 'react';
import { FaTimes, FaDownload, FaUpload, FaCheckCircle, FaExclamationTriangle, FaInfoCircle, FaTimesCircle } from 'react-icons/fa';

const Notification = ({ notification, onClose }) => {
  if (!notification) return null;

  const getIcon = (type) => {
    switch (type) {
      case 'success': return <FaCheckCircle />;
      case 'error': return <FaTimesCircle />;
      case 'warning': return <FaExclamationTriangle />;
      case 'info': 
      case 'progress': return <FaInfoCircle />;
      default: return <FaInfoCircle />;
    }
  };

  const getNotificationClass = () => {
    let classes = ['notification', `notification-${notification.type}`];
    
    if (notification.isImportExport) {
      classes.push('notification-import-export');
      if (notification.isMobile) {
        classes.push('notification-mobile-import-export');
      } else {
        classes.push('notification-desktop-import-export');
      }
    } else if (notification.isProverbAction) {
      classes.push('notification-proverb-action');
      if (notification.position === 'bottom') {
        classes.push('notification-bottom');
      }
      if (notification.isMobile) {
        classes.push('notification-mobile-proverb');
      } else {
        classes.push('notification-desktop-proverb');
      }
    } else if (notification.isDetailed) {
      classes.push('detailed');
    }
    
    return classes.join(' ');
  };

  // Import/Export Big Notification
  if (notification.isImportExport) {
    return (
      <div className={getNotificationClass()}>
        <div className="notification-backdrop" onClick={onClose}></div>
        <div className="notification-modal">
          <div className="notification-header">
            <div className="notification-icon-large">
              {notification.title?.includes('Import') ? <FaUpload /> : <FaDownload />}
              {getIcon(notification.type)}
            </div>
            <div className="notification-title-large">{notification.title}</div>
            <button onClick={onClose} className="notification-close-large">
              <FaTimes />
            </button>
          </div>
          <div className="notification-content-large">
            <div className="notification-message">{notification.message}</div>
            {notification.progress && (
              <div className="notification-progress">
                <div className="progress-bar">
                  <div 
                    className="progress-fill" 
                    style={{ width: `${notification.progress}%` }}
                  ></div>
                </div>
                <div className="progress-text">{notification.progress}%</div>
              </div>
            )}
          </div>
          {!notification.isMobile && (
            <div className="notification-footer">
              <small>This window will close automatically in a few seconds</small>
            </div>
          )}
        </div>
      </div>
    );
  }

  // Proverb Action Bottom Notification
  if (notification.isProverbAction) {
    return (
      <div className={getNotificationClass()}>
        <div className="notification-icon">
          {getIcon(notification.type)}
        </div>
        <span className="notification-content">{notification.message}</span>
        <button onClick={onClose} className="notification-close">
          <FaTimes />
        </button>
      </div>
    );
  }

  // Default/Detailed Notification
  return (
    <div className={getNotificationClass()}>
      {notification.isDetailed ? (
        <>
          <div className="notification-header">
            <div className="notification-icon">
              {getIcon(notification.type)}
            </div>
            <div className="notification-title">{notification.title}</div>
            <button onClick={onClose} className="notification-close">
              <FaTimes />
            </button>
          </div>
          <div className="notification-content">{notification.message}</div>
        </>
      ) : (
        <>
          <div className="notification-icon">
            {getIcon(notification.type)}
          </div>
          <span className="notification-content">{notification.message}</span>
          <button onClick={onClose} className="notification-close">
            <FaTimes />
          </button>
        </>
      )}
    </div>
  );
};

export default Notification;
